/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CspAgreementStats
 */
export interface CspAgreementStats {
  /**
   *
   * @type {number}
   * @memberof CspAgreementStats
   */
  quoteCount: number;
  /**
   *
   * @type {number}
   * @memberof CspAgreementStats
   */
  bookingCount: number;
  /**
   * Unique booked shipments divided by unique quoted shipments, 0..1. Both sides are
   * deduplicated by shipment_hash, so this is not bookingCount / quoteCount.
   *
   * @type {number}
   * @memberof CspAgreementStats
   */
  winRate: number;
  /**
   * ISO instant of the most recent quote.
   * @type {string}
   * @memberof CspAgreementStats
   */
  lastQuotedAt?: string;
  /**
   * ISO instant of the most recent booking.
   * @type {string}
   * @memberof CspAgreementStats
   */
  lastBookedAt?: string;
  /**
   *
   * @type {number}
   * @memberof CspAgreementStats
   */
  totalPaidCad: number;
  /**
   *
   * @type {number}
   * @memberof CspAgreementStats
   */
  averagePaidPerShipmentCad: number;
}

/**
 * Check if a given object implements the CspAgreementStats interface.
 */
export function instanceOfCspAgreementStats(
  value: object,
): value is CspAgreementStats {
  if (!("quoteCount" in value) || value["quoteCount"] === undefined)
    return false;
  if (!("bookingCount" in value) || value["bookingCount"] === undefined)
    return false;
  if (!("winRate" in value) || value["winRate"] === undefined) return false;
  if (!("totalPaidCad" in value) || value["totalPaidCad"] === undefined)
    return false;
  if (
    !("averagePaidPerShipmentCad" in value) ||
    value["averagePaidPerShipmentCad"] === undefined
  )
    return false;
  return true;
}

export function CspAgreementStatsFromJSON(json: any): CspAgreementStats {
  return CspAgreementStatsFromJSONTyped(json, false);
}

export function CspAgreementStatsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CspAgreementStats {
  if (json == null) {
    return json;
  }
  return {
    quoteCount: json["quoteCount"],
    bookingCount: json["bookingCount"],
    winRate: json["winRate"],
    lastQuotedAt:
      json["lastQuotedAt"] == null ? undefined : json["lastQuotedAt"],
    lastBookedAt:
      json["lastBookedAt"] == null ? undefined : json["lastBookedAt"],
    totalPaidCad: json["totalPaidCad"],
    averagePaidPerShipmentCad: json["averagePaidPerShipmentCad"],
  };
}

export function CspAgreementStatsToJSON(json: any): CspAgreementStats {
  return CspAgreementStatsToJSONTyped(json, false);
}

export function CspAgreementStatsToJSONTyped(
  value?: CspAgreementStats | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    quoteCount: value["quoteCount"],
    bookingCount: value["bookingCount"],
    winRate: value["winRate"],
    lastQuotedAt: value["lastQuotedAt"],
    lastBookedAt: value["lastBookedAt"],
    totalPaidCad: value["totalPaidCad"],
    averagePaidPerShipmentCad: value["averagePaidPerShipmentCad"],
  };
}
